import * as S from './styles';
import { Warning, Info, CheckCircle } from '@mui/icons-material';
import { colors } from '../Colors';
import { Severity } from '../types/severity';

declare type SectionProps = {
    title?: string;
    description?: string;
    type?: Severity;
}

export default function Section({ title, description, type }: SectionProps) {
    return (
        <S.Container $type={type}>
            <S.Heading>
                {type === 'warning' && <Warning style={{ color: colors.warning }} />}
                {type === 'info' && <Info style={{ color: colors.info }} />}
                {type === 'success' && <CheckCircle style={{ color: colors.success }} />}
                {title ? <S.Title>{title}</S.Title> : description && <S.Description>{description}</S.Description>}
            </S.Heading>
            {title && description && <S.Description>{description}</S.Description>}
        </S.Container>
    )
}